export default [
  {
    path: 'regulation',
    name: 'regulation',
    component: () => import('@/views/pages/front/Regulation.vue'),
    meta: {
      pageTitle: 'Regulation',
      breadcrumb: [
        {
          text: 'Regulation',
          active: true,
        },
      ],
    },
  },
]
